<div class="container-fluid glb-popup" style="min-width: 800px; min-height: 800px">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100" style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-11">
          <span class="p-float-label required-field w-100 mb-3"><input formControlName="email" id="email" type="text" pInputText/><label for="email">Email</label>@for (validation of validationMessages.email; track validation) {
          <span>@if (
            (form1.get('email').hasError(validation.type) &&
            form1.get('email').dirty) ||
            form1.get('email').touched
            ) {
            <small class="p-invalid">{{ validation.message }}</small>
          }</span>
        }</span>
      </div>

      <div class="col-lg-1">
        <span class="p-float-label w-100 mb-3">
          <button pButton class="btn-addt p-button" (click)="findHistoryByMail();">Search</button>
        </span>
      </div>

      <div class="col-lg-12">

        <p-table
          #pt
          [value]="msgs"
          [lazy]="true"
          (onLazyLoad)="loadLazy($event)"
          dataKey="msgId"
          selectionMode="single"
          [(selection)]="msg"
          (onRowSelect)="onRowSelect($event)"
          [loading]="loading"
          [paginator]="showPagination"
          [rows]="25"
          [rowsPerPageOptions]="[25, 100, 200]"
          showCurrentPageReport="true"
          currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
          [totalRecords]="recordTotal"
          sortMode="multiple"
          [multiSortMeta]="multiSortMeta"
          styleClass="p-datatable-striped"
          [ngStyle]="{ width: 'auto' }"
          [resizableColumns]="true"
          [autoLayout]="true"
          [responsive]="true"
          >
          <ng-template pTemplate="header">
            <tr>
              @for (col of columns; track col) {
                <th
                  [pSortableColumn]="col.field"
                  [ngStyle]="{ width: auto }">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              }
              <th [ngStyle]="{ width: 'auto' }"></th>
            </tr>
            @if (showFilter) {
              <tr>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'msgId', 'in')" class="idFilter"></th>
                <th><p-dropdown #aa [options]="statuses" appendTo="body"
                  (onChange)="pt.filter($event.value, 'status', 'in')" [style]="{'width':'50px','min-width':'100%'}"
                  styleClass="p-column-filter" placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
                  <ng-template let-option pTemplate="item">
                    <span>{{option.name}}</span>
                  </ng-template>
                </p-dropdown>
              </th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderName', 'in')" style="width:100px;"></th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderEmail', 'in')" style="width:100px;"></th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'subject', 'in')" style="width:100px;"></th>
            </tr>
          }
        </ng-template>
        <ng-template pTemplate="body" let-msg>
          <tr [pSelectableRow]="msg">
            <td>{{ msg.createDate|date:'medium' }}</td>
            <td>{{ msg.receivedDate|date:'medium' }}</td>
            <td>{{ msg.sentDate|date:'medium'  }}</td>
            <td>{{ msg.senderName }}</td>
            <td>{{ msg.senderEmail }}</td>
            <td>{{ msg.subject }}</td>

          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
</div>
</div>
